<div class="modal-backdrop fixed inset-0 z-150 flex items-center justify-center p-4">
  <div class="modal-content w-full max-w-lg rounded-2xl overflow-hidden" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="flex items-center justify-between px-6 py-4 border-b border-white/10">
      <h2 class="text-xl font-semibold text-text-primary">{{ title }}</h2>
      <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="close()">
        <span class="material-icons text-xl">close</span>
      </button>
    </div>

    <!-- Form -->
    <form [formGroup]="textBlockForm" (ngSubmit)="submit()" class="p-6">
      <div class="space-y-5">
        <!-- Title -->
        <div class="form-group">
          <label for="title" class="form-label">Titel *</label>
          <input
            type="text"
            id="title"
            formControlName="title"
            class="form-input"
            [class.error]="isFieldInvalid('title')"
            placeholder="Titel des Textblocks"
          />
          @if (isFieldInvalid('title')) {
            <span class="form-error">{{ getFieldError('title') }}</span>
          }
        </div>

        <!-- Type -->
        <div class="form-group">
          <label for="type" class="form-label">Typ *</label>
          <p-select
            inputId="type"
            formControlName="type"
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Typ wählen"
            [filter]="false"
            appendTo="body"
            styleClass="select-component-style"
            panelStyleClass="select-component-panel-style"
          >
            <ng-template pTemplate="item" let-option>
              <div class="option-row">
                <span class="option-label">{{ option.label }}</span>
              </div>
            </ng-template>
          </p-select>
          @if (isFieldInvalid('type')) {
            <span class="form-error">{{ getFieldError('type') }}</span>
          }
        </div>

        <!-- Description -->
        <div class="form-group">
          <label for="description" class="form-label">Beschreibung *</label>
          <textarea
            id="description"
            formControlName="description"
            class="form-input min-h-[100px] resize-none"
            [class.error]="isFieldInvalid('description')"
            placeholder="Beschreibung des Textblocks"
            rows="4"
          ></textarea>
          @if (isFieldInvalid('description')) {
            <span class="form-error">{{ getFieldError('description') }}</span>
          }
        </div>
      </div>

      <!-- Actions -->
      <div class="flex items-center justify-end gap-3 mt-8 pt-6 border-t border-white/10">
        <button type="button" class="btn-secondary px-5 py-2.5 text-sm" (click)="close()">Abbrechen</button>
        <button type="submit" class="btn-primary px-5 py-2.5 text-sm" [disabled]="isSubmitting">
          @if (isSubmitting) {
            <span class="flex items-center gap-2">
              <span class="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></span>
              Speichern...
            </span>
          } @else {
            {{ isEditMode ? 'Speichern' : 'Hinzufügen' }}
          }
        </button>
      </div>
    </form>
  </div>
</div>
